<script lang="ts">
import { defineComponent } from "vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "DateiUploadListe",
  components: {},
  props: {},
  setup: () => {
    const piniaStore = useFormStore();

    return {
      piniaStore,
    };
  },
});
</script>

<template>
  <div class="upload">
    <template v-if="piniaStore.state.dateien.length">
      <span v-for="(file, index) in piniaStore.state.dateien" :key="file.id">
        {{ index > 0 ? ", " : "" }}
        {{ file.name }}
      </span>
    </template>
    <span v-else>keine</span>
  </div>
</template>

<style scoped></style>
